export class CreditsMonthlyUsageNotificationArguments {
    'totalCredits';
    'expectedMonthlyCredits';
    'actualMonthlyCredits';
    'contractMonths';
    'agreementId';
    'thresholdPercentage';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalCredits",
            "baseName": "totalCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "expectedMonthlyCredits",
            "baseName": "expectedMonthlyCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "actualMonthlyCredits",
            "baseName": "actualMonthlyCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contractMonths",
            "baseName": "contractMonths",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "agreementId",
            "baseName": "agreementId",
            "type": "string",
            "format": ""
        },
        {
            "name": "thresholdPercentage",
            "baseName": "thresholdPercentage",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return CreditsMonthlyUsageNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
